import { render, staticRenderFns } from "./StoryItem.vue?vue&type=template&id=509d6ff2&"
import script from "./StoryItem.vue?vue&type=script&lang=js&"
export * from "./StoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports